import React, {useEffect, useState} from 'react'
import classNames from 'classnames'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import AppBar from '@material-ui/core/AppBar'
import {CircularProgress, Snackbar, withStyles} from '@material-ui/core'
import {drawerWidth} from '../config'
import IconButton from "@material-ui/core/IconButton/IconButton";
import { Redirect} from "react-router-dom";
import logo from "../assets/images/logo.png";
import {connect, useDispatch, useSelector} from "react-redux";
import UserMenuNavBar from "../common/UserMenuNavBar";
import Container from "@material-ui/core/Container/Container";
import MainRouting from "../routes/mainRouting.jsx";
import Sidebar from "../common/Sidebar";
import { withRouter } from 'react-router-dom'
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import {getEstabelecimentos, setEstabelecimento} from "../actions/FilterActions";
import {authLogout} from "../actions/authAction";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import Help from "../common/Help";
import {getDadosPneus} from "../actions/tireActions";
import {getProcessos} from "../actions/i4Actions";
import {makeStyles} from "@material-ui/core/styles";
import {getOSMovimentadasDetalhadoV2} from "../actions/orderActions";
import * as config from "../config";
import {getAutoclaves} from "../actions/autoclaveActions";

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    display: 'flex'

  },
  mainContentWidth: {
    // width: `calc(100% - ${drawerWidth}px) !important`,
    // marginRight: '0px',
  },
  mainContent: {
    // top: '40px',
    marginTop: '60px',
    maxWidth: '90%',
    display: 'flex',
    flexWrap: 'nowrap',
    height: '100vh',
    disableGutters: true
  },
  container: {
    justifyContent: 'flex-start',
    flexWrap: 'nowrap',
    width: '100%',
    //marginTop: theme.spacing(1) * 12
  },
  appBar: {

    display: 'flex',
    justifyContent: 'space-between',
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    minHeight: '40px',
   // height: '40px'
  },
  navLogo: {
   // height: "20px",
    width: "105px",
    verticalAlign: 'middle'
  },
  menuButton: {
    marginLeft: 12,
    marginRight: 36,
    align: 'left'
  },
  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
    justifyContent: 'flex-end',
    minHeight: '48px !important',
  },
  removeRadius: {
    borderRadius: '0px !important',
  },
  drawer: {
    width: drawerWidth,
    fontSize: '.625rem',
    top: '49px',
    whiteSpace: 'nowrap',
    lineHeight: '2rem',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },


  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 0px',
    ...theme.mixins.toolbar,
  },
  content: {
    flex: 1,
    borderStyle: 'groove',
    borderColor: 'cadetblue',
    borderWidth: 5,
    padding: theme.spacing(1) * 3,
    left: 'auto'
  },
  contentDrawerOpen: {
    marginLeft: drawerWidth
  },
  contentDrawerClose: {
    marginLeft: '40px'
  },

}));


const  AppBase = ( props ) =>  {
  const { pageTitle} = props;
  // const auth = useSelector( state => state.auth);
  const filter = useSelector(state => state.filter);
  const estabelecimentoId = useSelector(state => state.filter.estabelecimentoId);
  const classes = useStyles();
  const [drawerState,setDrawerState] = useState(2);
  const [isHelpOpen,setIsHelpOpen] = useState(false);
  const [open,setOpen] = useState(false);
  const estabelecimentosLoading = useSelector( state => state.filter.estabelecimentosLoading);
  const estabelecimentos = useSelector( state => state.filter.estabelecimentos);
  const  isAuthenticated = useSelector( state => state.auth.id !== null && (state.auth.expiresIn * 1000 > new Date().getTime()));
  // const isFetchingOS = useSelector(state => state.v2.isFetchingOS);
  const v2periodoIni = useSelector(state => state.v2.periodoIni);
  const v2periodoFim = useSelector(state => state.v2.periodoFim);
  const periodMin = useSelector(state => state.filter.periodMin);
  const periodMax = useSelector(state => state.filter.periodMax);

  const uId =  useSelector(state => state.auth.userId);
  const demo = uId === 268;

  const imglogoCliente = `http://arq-tipler.digama.com.br/images/tnt${config.getTntFolder()}/logoEmpresaBco.png`;



  const dispatch = useDispatch();

  useEffect(()=>{
    document.title = `i4 - ${config.VERSAO}`;
    if (isAuthenticated) {
      dispatch(getEstabelecimentos());
      dispatch(getDadosPneus());
      dispatch(getProcessos());
      dispatch(getAutoclaves());
    }
  },[isAuthenticated]);

  useEffect(()=>{
    console.log("useEffect  estabelecimentoId", estabelecimentoId);
    if (estabelecimentoId < 90) {
      dispatch(getAutoclaves());
    }
  },[estabelecimentoId]);

  useEffect(()=>{
    console.log("appbase.useeffect(periodo....estabid)  estab", estabelecimentoId);
    //console.log("teste getOSMovimentadasDetalhadoV2", estabelecimentoId, isFetchingOS, periodMin, v2periodoIni, periodMax, v2periodoFim);
     // if (estabelecimentoId < 90 && !isFetchingOS && (periodMin !== v2periodoIni || periodMax !== v2periodoFim )) {
     //   dispatch(getOSMovimentadasDetalhadoV2())
     // }

  },[periodMin,periodMax, v2periodoIni, v2periodoFim, estabelecimentoId]);




  if (!isAuthenticated) {
    console.log("appbase.render.redirectToLogin");
    return (<div><Redirect to="/login"/></div>);
  }


  if (estabelecimentosLoading ) {
    console.log("Estabelecimentos nao carregado, aguardar", estabelecimentoId)
    return (<CircularProgress/>);
  }


  const openDialog = () => {
    setIsHelpOpen(true);
  };

  const closeDialog = () => {
      setIsHelpOpen(false);
  };

  const handleDrawer = () => {
    let drawerState = 0;
    switch(drawerState) {
      case 0:
        setDrawerState(1);
        break;
      case 1:
        setDrawerState(2);
        break;
      case 2:
        setDrawerState(0);
        break;
      default:
        setDrawerState(2);
    }
  };

  const setnewEstabelecimento = (estab) => {
    localStorage.setItem('estabId', estab);
    dispatch(setEstabelecimento(estab));
  }





    if (estabelecimentoId > 90  || estabelecimentos.length === 0  || estabelecimentosLoading ) {
      console.log("Estabelecimentos nao carregado, aguardar", estabelecimentoId)
      return (<CircularProgress/>);
    }

    console.log("estabelecimentos", estabelecimentoId, estabelecimentos);


    return (
      <div className={classes.root}>
        <AppBar position="fixed"
                className={classes.appBar}
        >
          <Toolbar className={classes.appBar} disableGutters={false}>
            <div>
              <IconButton onClick={handleDrawer} className={classes.removeRadius}>
                <img src={demo? imglogoCliente : logo} className={classes.navLogo} alt='logo'/>
              </IconButton>
              <Typography variant="h6" color="inherit">{pageTitle}</Typography>
            </div>

            <div style={{display:'flex', justifyContent: 'space-between'}}>
              <div>
                <IconButton color="secondary" onClick={openDialog} >
                  <HelpOutlineIcon />
                </IconButton>
                <Help isOpen={isHelpOpen} closeDialog={closeDialog}/>
              </div>
              <div>
              <FormControl style={{paddingTop: '10px'}} className={classes.formControl}>
                <Select
                    name="inputEstabelecimentoId"
                    value={estabelecimentoId}
                    onChange={e => setnewEstabelecimento(e.target.value)}
                    displayEmpty className={classes.selectEmpty}>
                  <MenuItem value="" disabled>
                    Estabelecimento
                  </MenuItem>
                  {estabelecimentos.map( (e,ix) => {
                    return <MenuItem key={ix} value={e.id}>{e.descricao}</MenuItem>
                  })}

                </Select>
                {/*<FormHelperText>Placeholder</FormHelperText>*/}

              </FormControl>
              </div>
              <div>
                {/*<Snackbar*/}
                {/*    open={isFetchingOS}*/}
                {/*    anchorOrigin={ {vertical: 'top', horizontal: 'center'}}*/}
                {/*    message="Carregando Ordens de Servico, aguarde..."*/}
                {/*/>*/}
                <div style={{paddingTop: '10px'}}>
                  <UserMenuNavBar/>
                </div>
              </div>
            </div>
          </Toolbar>
        </AppBar>
          <Sidebar status={drawerState}/>
          <Container id="mainContent" maxWidth={"xl"} className={classNames(classes.container, {[classes.mainContent]: true}, {[classes.mainContentWidth]: open})}>
            <main className={classNames(classes.container, {})}>


              {  ( (estabelecimentos.length > 0 ) &&
                  !( (estabelecimentos.length === 1 && estabelecimentos[0].fake))
                  && !estabelecimentosLoading ) &&
                <MainRouting/>
              }

            </main>
          </Container>
      </div>
    )

}

export default AppBase;
